/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var plugin  = require('../plugin'),
    langs   = require('../langs.full'),
    gettext = require('mag-gettext').gettext,
    data    = [],
    lang;

for ( lang in langs['1'] ) {
    data.push({
        value: lang,
        name: langs['1'][lang].local + ' (' + langs['1'][lang].name + ')'
    });
}

function save ( val ) {
    var langToSave;

    langToSave = langs.getLangByCode(val);

    if ( !langToSave ) {
        return;
    }

    console.log('SET AUDIO:' + val);


    plugin.audioLanguages = [langToSave['1'], langToSave['2T'], langToSave['2B']];

    if ( top.stbPlayerManager && top.stbPlayerManager.list ) {
        top.stbPlayerManager.list.forEach(function ( player ) {
            player.audioPrimaryLanguage = langToSave['1'];
            player.audioLanguages = [langToSave['1'], langToSave['2T'], langToSave['2B']];
        });
    } else {
        top.gSTB.SetAudioLangs(val['1']); //eslint-disable-line
    }
}


module.exports = function ( app ) {
    return {
        id: 'audioLangs',
        name: gettext('Primary audio track language'),
        description: gettext('Setting the default audio track. If the default audio track is not selected for a video you are playing, then the video is played with the first available track.'), //eslint-disable-line
        icon: 'theme-icon-equalizer',
        saveImmediate: true,
        variable: {
            name: 'pri_audio_lang',
            value: 'en'
        },
        prepareForRender: function ( value, callback ) {
            data.forEach(function ( item ) {
                item.selected = item.value === value;
            });
            callback(data);
        },
        prepareForSave: function ( value, callback ) {
            this.variable.value = value;

            save(value);
            callback();
        },
        render: app.api.renders.popupSelect,
        getter: app.api.getters.userSettings,
        saver: app.api.savers.userSettings,
        parent: 'playback'
    };
};


module.exports.setValue = save;
